import AddNewDepartmentModal from './SubComponent/AddNewDepartmentModal';
import DeleteModal from '../../Modals/DeleteModal';
import { permissionObj } from '../../../Helpers/permission';
import NotInformation from '../../../components/NotInformation';
import SearchSimple from '../../../components/SearchSimples/SearchSimple';
import HeadTittle from "../../../components/HeadTittle";
import ButtonAction from "../../../components/buttons/ButtonAction";
import {AddIcon, TrashOutlineIcon} from "../../../components/buttons/IconButtons";
import {DepartmentApp} from "./Funtionallity/DepartmentApp";
import React from "react";
import CustomExpandableTable from "../../../components/table/CustomExpandableTable";
import RenderExpandedRow from "./SubComponent/RenderExpandedRow";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 * @returns {JSX.Element}
 * @constructor
 */

const Department = () => {

    const{  DEV, t,permission, searchElement, setSearchElement, setBodyForExport, setSearchResults, option,
        setSearch, simpleSearch, setSimpleSearch, contractorId, supplierId,setAddShow,page,
        setIsUpdate,handleCheckboxChange, setUpdateData, handleDeleteAll,addShow, isUpdate, updateData,
        selectedList,deleteModal, searchResults, columns, renderOptionsMenu, handleRowExpand, rowsPerPage,
        pagination, modalDeleteDepartments, setModalDeleteDepartments, setSelectedList,setModified ,modified
    } = DepartmentApp()

    return (
        <>
            <HeadTittle name={'departments'}>
                {(DEV || permission?.includes(permissionObj?.WEB_DEPARTMENT_CREATE)) && (
                    <ButtonAction
                        id='btn_d_add'
                        name='create'
                        className='btn-icon-add'
                        Icon={AddIcon}
                        onClick={() => {
                            setAddShow(true);
                            setIsUpdate(false);
                        }}
                    />
                )}
                {(DEV || permission?.includes(permissionObj?.WEB_DEPARTMENT_DELETE)) && (
                    <ButtonAction
                        id='btn_d_delete'
                        name='delete'
                        className='btn-icon-delete'
                        disabled={selectedList?.length === 0}
                        Icon={TrashOutlineIcon}
                        onClick={() => {
                            setModalDeleteDepartments(true);
                        }}
                    />
                )}
            </HeadTittle>

            <SearchSimple
                id={"txt_dpt_search_simple"}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                setBodyForExport={setBodyForExport}
                setSearchResults={setSearchResults}
                optionTable={option}
                rowsPerPage={rowsPerPage}
                setSearch={setSearch}
                simpleSearch={simpleSearch}
                setSimpleSearch={setSimpleSearch}
                contractorId={contractorId}
                supplierId={supplierId}
            />
            {searchResults?.content?.length > 0 ? (
                <>
                    {/**Done*/}
                    <CustomExpandableTable
                        columns={columns}
                        rows={searchResults.content}
                        renderExpandedRow={RenderExpandedRow}
                        renderOptionsMenu={(DEV || permission?.includes(permissionObj?.WEB_DEPARTMENT_UPDATE)) && (renderOptionsMenu)}
                        onRowExpand={handleRowExpand}
                        selectedList={selectedList}
                        handleCheckboxChange={handleCheckboxChange}
                        handleDeleteAll={handleDeleteAll}
                        rowsPerPage={rowsPerPage}
                    />
                    {pagination()}
                </>
            ) : (
                <NotInformation
                    card={true}
                    text={t('no_department_text')}
                    showButton={((DEV || permission?.includes(permissionObj?.WEB_DEPARTMENT_CREATE)) && searchResults?.content?.length === 0)}
                    buttonId={'btn_zn_link_create'}
                    buttonOnclick={() =>   {
                        setAddShow(true);
                        setIsUpdate(false);}}
                    buttonTrans={'created_department'}
                />
            )}
            <AddNewDepartmentModal
                show={addShow}
                onHide={() => setAddShow(false)}
                title={''}
                check='false'
                isUpdate={isUpdate}
                data={updateData}
                setData={setUpdateData}
                setIsUpdate={setIsUpdate}
                setModified={setModified}
                modified={modified}
            />

            <DeleteModal
                show={modalDeleteDepartments}
                onHide={() => setModalDeleteDepartments(false)}
                data={selectedList}
                onClickFn={() => deleteModal(selectedList)}
                title_modal={'delete'}
                element_modal={'department'}
                description={'are_you_sure_you_want_to_delete'}
                isReset={setSelectedList}
            />

        </>
    );
};

export default Department;
